import React, { createContext, useReducer, useContext } from "react";
import CustomerReducer from "../reducers/CustomerReducer";
import CustomerService from "../services/CustomerService";
import { CUSTOMERS_RECIBIDOS, SET_CUSTOMER } from "../types";
import { hideModal } from "../utils";
import { ModalContext } from "./ModalContext";

const initialState = {
  customers: null,
  customer: null,
};

export const CustomerContext = createContext(initialState);

export const CustomerProvider = ({ children }) => {
  const [state, dispatch] = useReducer(CustomerReducer, initialState);

  const { success } = useContext(ModalContext);

  const getCustomersByQuery = (query) => {
    CustomerService.getCustomersByQuery(query).then((res) => {
      const { customers } = res.data;
      dispatch({ type: CUSTOMERS_RECIBIDOS, payload: customers });
    });
  };

  const getAllCustomers = (query) => {
    dispatch({ type: CUSTOMERS_RECIBIDOS, payload: null });
    CustomerService.getAllCustomers(query).then((res) => {
      const { customers } = res.data;
      dispatch({ type: CUSTOMERS_RECIBIDOS, payload: customers });
    });
  };

  const getCustomer = (customer_id) => {
    CustomerService.getCustomer(customer_id).then((res) => {
      dispatch({ type: SET_CUSTOMER, payload: res.data });
    });
  };

  const extenderAcceso = (
    customer_id,
    package_class_id,
    package_days,
    is_gift,
    payment_method_id
  ) => {
    CustomerService.extenderAcceso(
      customer_id,
      package_class_id,
      package_days,
      is_gift,
      payment_method_id
    ).then(() => {
      success("¡Acceso extendido!");
      getCustomer(customer_id);
      hideModal();
    });
  };

  return (
    <CustomerContext.Provider
      value={{
        ...state,
        getCustomer,
        getAllCustomers,
        getCustomersByQuery,
        extenderAcceso,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};
